import React from "react";
import { DataGridHeader } from "./DataGridHeader";
import { DataGridPagination } from "./DataGridPagination";
import { DataGridRecords } from "./DataGridRecords";
import { DataGridSearch } from "./DataGridSearch";
import { useScreenSize } from "hooks/useScreenSize";

export const DataGrid = ({
  columns,
  mobileColumns = columns,
  handleRowClick,
  search,
  handleChangeSearch,
  clearSearch,
  limit,
  currentPage,
  totalPages,
  handleChangeRecordsPerPage,
  handleChangePage,
  sorter,
  handleSort,
  rows,
  totalCount,
  visibility,
  setVisibility,
  defaultLimit,
  afterSearchContent = null,
  loadData,
  withRefreshButton = false,
  disableDownload = false,
  getHandleDownload,
  isFirstLoad,
  highlightRowName = undefined,
  highlightRowValue = undefined,
}) => {
  const { isMobileWidth } = useScreenSize();

  return (
    <>
      <DataGridSearch
        search={search}
        handleChangeSearch={handleChangeSearch}
        clearSearch={clearSearch}
        columns={isMobileWidth ? mobileColumns : columns}
        visibility={visibility}
        setVisibility={setVisibility}
        afterSearchContent={afterSearchContent}
        loadData={loadData}
        withRefreshButton={withRefreshButton}
      />
      <DataGridHeader
        columns={isMobileWidth ? mobileColumns : columns}
        sorter={sorter}
        handleSort={handleSort}
        visibility={visibility}
        isMobileWidth={isMobileWidth}
      />
      <DataGridRecords
        columns={isMobileWidth ? mobileColumns : columns}
        rows={rows}
        handleRowClick={handleRowClick}
        visibility={visibility}
        isMobileWidth={isMobileWidth}
        isFirstLoad={isFirstLoad}
        highlightRowName={highlightRowName}
        highlightRowValue={highlightRowValue}
      />
      <DataGridPagination
        currentPage={currentPage}
        handleChangePage={handleChangePage}
        defaultLimit={defaultLimit}
        limit={limit}
        handleChangeRecordsPerPage={handleChangeRecordsPerPage}
        totalPages={totalPages}
        count={totalCount}
        disableDownload={disableDownload}
        handleDownload={getHandleDownload(columns)}
      />
    </>
  );
};
